import React from 'react';
import ReactDOM from 'react-dom/client';
import './Global.css'; // Branding & Theme Variables
import './index.css';  // Fonts & Base Resets
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configureAxios } from './axiosConfig';

// Configure axios to add authorization headers for API calls
configureAxios();

// Apply saved theme before first paint to avoid flash/flicker on mount.
const initialTheme = localStorage.getItem('signtada-theme') || 'dark';
document.documentElement.setAttribute('data-theme', initialTheme);
document.documentElement.style.colorScheme = initialTheme === 'dark' ? 'dark' : 'light';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode is commented out to prevent double-invocations in dev mode,
  // which can sometimes cause issues with PDF rendering or auth flows.
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();
